<template>
  <v-container class="controlled-font">
    <!-- Test Controls -->
    <v-card v-if="page == 1">
      <app-card-header :text="siteText.ui.testControls"></app-card-header>
      <v-card-text class="pb-10">
        <v-row>
          <v-col sm="4" class="mx-auto text-center">
            <v-toolbar class="primary mx-auto" dark height="50" width="230">
              <v-select
                class="mt-7 language-select controlled-font mx-auto"
                dense
                outlined
                :items="Languages"
                item-text="Name"
                item-value="Code"
                value="en"
              ></v-select>
            </v-toolbar>
          </v-col>
          <v-col sm="8" class="controlled-font">
            {{ siteText.ui.instructionsLanguages }}
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="4" class="mx-auto text-center">
            <v-btn
              depressed
              outlined
              id="toggle"
              class="primary btn-toggle mr-5"
              @click="toggle = !toggle"
            >
              <v-icon v-if="!toggle">$apIncreaseFont</v-icon>
              <v-icon v-else>$apDecreaseFont</v-icon>
            </v-btn>
          </v-col>
          <v-col sm="8" class="controlled-font">
            {{ siteText.ui.instructionsFontToggle }}
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="4" class="mx-auto text-center">
            <v-btn class="primary controlled-font"
              >{{ siteText.ui.next }}
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>
          <v-col sm="8">
            <div class="controlled-font">
              {{ siteText.ui.instructionsNextQuestion }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="4" class="mx-auto text-center">
            <v-btn class="primary controlled-font">
              <v-icon left>mdi-arrow-left</v-icon>
              {{ siteText.ui.previous }}
            </v-btn>
          </v-col>
          <v-col sm="8">
            <div class="controlled-font">
              {{ siteText.ui.instructionsPreviousQuestion }}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="4" class="mx-auto text-center">
            <v-btn class="primary controlled-font"
              >{{ siteText.ui.skipQuestion }}
              <v-icon>mdi-share-outline</v-icon>
            </v-btn>
          </v-col>
          <v-col sm="8">
            <div class="controlled-font">
              {{ siteText.ui.instructionsSkipQuestion }}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="4" class="text-center mx-auto">
            <v-chip class="primary px-10 controlled-font">1/10</v-chip>
          </v-col>
          <v-col sm="8" class="controlled-font">
            {{ siteText.ui.instructionsQuestionProgress }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- Audio / Video -->
    <v-card v-else-if="page == 2">
      <app-card-header text="Audio/Video Controls"></app-card-header>
      <v-card-text class="controlled-font black--text">
        <p class="py-5">
          {{ siteText.ui.instructionsAudio }}
        </p>
        <v-card class="mx-auto mt-4">
          <v-card-title class="primary white--text controlled-font">
            <v-row>
              <v-col sm="10">
                <v-icon controlled-font center color="white" v-if="toggle"
                  >$apASL</v-icon
                >
                <v-icon v-else color="white">mdi-account-voice</v-icon>

                {{ !toggle ? siteText.ui.audioTitle : siteText.ui.aslTitle }}
              </v-col>
              <v-col sm="2" class="text-right mx-auto">
                <!-- <img :src="aslWhite" class="icon" /> -->
                <v-btn
                  depressed
                  outlined
                  id="toggle"
                  class="primary btn-toggle"
                  @click="toggle = !toggle"
                >
                  <v-icon large center color="white" v-if="!toggle"
                    >$apASL</v-icon
                  >
                  <v-icon v-else center color="white">mdi-account-voice</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-layout row class="ma-2">
              <v-flex sm6 class="text-center align-bottom">
                <app-video-player
                  v-if="toggle"
                  :playList="video"
                  :autoPlay="true"
                >
                </app-video-player>
                <app-audio-player
                  v-else
                  class="mt-2 ml-2 mb-0"
                  :playList="audio"
                  :defaultVolume="defaultAudioVolume"
                  width="500"
                ></app-audio-player>
              </v-flex>
            </v-layout>
          </v-card-text> </v-card
      ></v-card-text>
    </v-card>

    <v-row class="pt-10">
      <v-col sm="4">
        <v-btn
          class="primary controlled-font"
          @click="page--"
          :disabled="page === 1"
        >
          <v-icon left>mdi-arrow-left-bold</v-icon>
          {{ siteText.ui.previous }}</v-btn
        >
      </v-col>
      <v-col sm="4">
        <v-btn
          class="primary controlled-font"
          @click="onNext"
          :disabled="page === 3"
          >{{ siteText.ui.next }}
          <v-icon right>mdi-arrow-right-bold</v-icon>
        </v-btn>
      </v-col>
      <v-col sm="4">
        <v-btn class="primary controlled-font" @click="onSkipInstructions"
          >{{ siteText.ui.skipInstructions }}
          <v-icon right>mdi-share-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

import "../assets/css/app.css";

import appCardHeader from "../components/ui/CardHeader.vue";
import appAudioPlayer from "../components/audioPlayer/AudioPlayer.vue";
import appVideoPlayer from "../components/videoPlayer/VideoPlayer.vue";

const SAMPLE_AUDIO_FILE = "/audio/en/testInstructionsSoundClip.mp3";

export default {
  components: {
    appCardHeader,
    appAudioPlayer,
    appVideoPlayer,
  },
  data() {
    return {
      toggle: false,
      page: 1,
      videoSample: require("../assets/Asl Sample Video-8.mp4"),
    };
  },
  async mounted() {
    if (this.testInstructionsDisplayed) {
      this.onSkipInstructions();
    } else {
      this.setTestInstructionsDisplayed(true);
    }
  },
  computed: {
    ...mapGetters([
      "siteText",
      "pages",
      "baseApiUrl",
      "defaultAudioVolume",
      "testInstructionsDisplayed",
      "userSession",
      "mediaUrl",
    ]),
    Languages() {
      return [
        { Name: "English", Code: "en" },
        { Name: "Espanol", Code: "es" },
      ];
    },
    audio() {
      return [
        `${this.mediaUrl}${SAMPLE_AUDIO_FILE}?${this.userSession.authToken.sasToken}`,
      ];
    },
    video() {
      return [this.videoSample];
    },
  },
  methods: {
    ...mapActions(["SetPage", "setTestInstructionsDisplayed"]),
    onSkipInstructions() {
      this.SetPage(this.pages.Test.name);
    },
    onNext() {
      if (this.page >= 2) {
        this.SetPage(this.pages.PracticeTest.name);
      }
      ++this.page;
    },
  },
};
</script>

<style scoped>
.language-select {
  max-width: 200px;
}

.v-card__text .col .v-btn {
  width: 275px;
}

#toggle.v-btn {
  max-width: 25px;
}

.btn-toggle.v-btn--outlined {
  border: 0.1rem lightgray solid !important;
}

.v-toolbar {
  border-radius: 5px;
}
</style>
